import {
  UPLOAD_EXTENSIONS,
  UPLOAD_FILE_ACCEPT,
  partitionUploadFiles,
} from "utils/files/uploadFileTypes";

/**
 * Attachments accept every upload type (documents and spreadsheets as well as
 * images), unlike receipts, which are images plus PDF only. See
 * `receiptFileTypes` for that narrower list.
 */
export const ATTACHMENT_FILE_ACCEPT = UPLOAD_FILE_ACCEPT;

/**
 * Split a selection into supported files and rejected filenames.
 *
 * Needed because `accept` only filters the click picker: a dragged file reaches
 * the handler whatever its type. The dropzone this replaced did this filtering
 * itself, so dropping it silently let unsupported files through to payments,
 * expenses and invoices.
 */
export const partitionAttachmentFiles = (files: FileList | File[]) =>
  partitionUploadFiles(files, UPLOAD_EXTENSIONS);
